<div class="checkbox" (click)="toggle()" [ngClass]="type">
    <input type="checkbox" [(ngModel)]="checked" [id]="id" />
    <span class="checkmark" [ngClass]="{ checked: checked }">
        <app-icon *ngIf="checked" [type]="'Check'"></app-icon>
    </span>
</div>
<label *ngIf="gtmLabel" [for]="id" class="checkbox-label">{{ gtmLabel }}</label>
